define([
    'jquery'
], function ($) {


    $.widget('aligent.modal', {
        options: {
            containerClass: '',
            contentsClass: '',
            overlayClass: '',
            modalDataIdentifier: 'data-modal__modal',
            headerClass: '',
            closeButtonClass: '',
            closeButtonDataIdentifier: 'data-modal__close',
            closeButtonHtml: undefined,
            onClose () {},
            captureEscapeKey: true,
            scrollLockBody: true,
            scrollLockClass: 'noScroll',
            attachToSelector: 'body',
            templateSelector: null,
            contentsDataIdentifier: 'data-modal__contents'
        },

        _create () {
            this.target = $(this.options.attachToSelector);
            if (this.options.scrollLockBody) $('html').addClass(this.options.scrollLockClass);

            const modal = $(this.getTemplate());
            this.element.append(modal);
            this.element.appendTo(this.target);

            this.content = '';

            this.elements = {
                overlay: modal,
                contents: modal.find(`[${this.options.contentsDataIdentifier}]`),
                container: modal.find(`[${this.options.containerSelector}]`),
                closeButton: modal.find(`[${this.options.closeButtonDataIdentifier}]`),
            };
            this.render();
            this.watch();

            return this.element;
        },

        watch () {
            if (this.options.captureEscapeKey) this.document.on('keydown', this.onKeyDown.bind(this));
            this.elements.container.on('click', this.onContainerClick.bind(this));
            this.elements.closeButton.on('click', this.onCloseButtonClick.bind(this));
            this.elements.overlay.on('mousedown', this.onOverlayClick.bind(this));
        },

        /**
         * Render the body of the modal
         *
         * @param {string} content HTML string to render
         */
        render (content = this.content) {
            this.elements.contents.html(content);
            this.element.find('[data-mage-init]').trigger('contentUpdated');
        },

        onCloseButtonClick () {
            this.close();
        },

        onContainerClick (event) {
            event.stopPropagation();
        },

        onOverlayClick (event) {
            if (event.target === this.elements.overlay.get(0)) {
                this.close();
            };
        },

        onKeyDown ({which}) {
            if(which == 27) {
                this.close();
            }
        },

        getTemplate () {
            return this.template || `<div class="popup_overlay popups-util__overlay ${this.options.overlayClass}" ${this.options.overlayDataIdentifier || ''}>
                <div class="popup_content popups-util__content ${this.options.containerClass}" ${this.options.modalDataIdentifier}>
                    <div class="popup_header popups-util__header ${this.options.headerClass}">
                        ${this.getCloseButtonTemplate()}
                        ${this.options.title && `<div class="popup_title">${this.options.title}</div>` || ''}
                    </div>
                    <div class="popup-contents popups-util__contents popups-util__body ${this.options.contentsClass}" ${this.options.contentsDataIdentifier}></div>
                </div>
            </div>`;
        },

        getCloseButtonTemplate () {
            return typeof this.options.closeButtonHtml == 'function' &&
                   this.options.closeButtonHtml(this.options) ||
                   this.options.closeButtonHtml ||
                   `<button class="popup_close popups-util__close-button ${this.options.closeButtonClass}" ${this.options.closeButtonDataIdentifier}><i class="material-icons">close</i></button>`;
        },

        close () {
            if (this.options.onClose &&
                typeof this.options.onClose === 'function'){
                this.options.onClose();
            }

            if (this.options.scrollLockBody) {
                $('html').removeClass(this.options.scrollLockClass);
            }

            this.element.trigger('close');
            this.element.remove();
            this._destroy();
        }
    });

    return $.aligent.modal;
});
